import React, { useId, useState } from 'react';
import './PasswordField.css';

function PasswordField({
  value,
  onChange,
  placeholder,
  name,
  autoComplete,
  required,
  inputStyle,
  ariaLabel,
  className,
  inputClassName,
  disabled,
  ...rest
}) {
  const [show, setShow] = useState(false);
  const inputId = useId();

  return (
    <div className={`password-field${className ? ` ${className}` : ''}`}>
      <input
        id={inputId}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        style={inputStyle}
        className={`password-field__input${inputClassName ? ` ${inputClassName}` : ''}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="password-field__toggle"
        disabled={disabled}
        aria-controls={inputId}
        aria-label={show ? `Hide ${ariaLabel || 'password'}` : `Show ${ariaLabel || 'password'}`}
      >
        {show ? '🙈' : '👁️'}
      </button>
    </div>
  );
}

export default PasswordField;
